import { LanguageCode } from 'translations/Language'
import { Nullable } from 'models/helpers'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

type TranslateFn = (key: string, options?: Record<string, unknown>) => string

const SUPPORTED_LANGUAGES = new Set<string>(Object.values(LanguageCode))

export const resolveConversationLanguage = (language: Nullable<string>): LanguageCode | null => {
  const normalized = language?.trim().toLowerCase()
  return normalized && SUPPORTED_LANGUAGES.has(normalized) ? normalized as LanguageCode : null
}

export const useLoadedConversationLanguage = (conversationLanguage: Nullable<string>): LanguageCode | null => {
  const { i18n } = useTranslation(['chat'])
  const language = resolveConversationLanguage(conversationLanguage)
  return language && i18n.hasResourceBundle(language, 'chat') ? language : null
}

export const useSystemNoticeTranslator = (conversationLanguage: Nullable<string>): TranslateFn => {
  const { t, i18n } = useTranslation(['chat'])
  const language = useLoadedConversationLanguage(conversationLanguage)

  return useMemo(() => {
    if (language) return i18n.getFixedT(language, 'chat') as TranslateFn
    return t as TranslateFn
  }, [language, i18n, t])
}
